import { isObject } from "../utils/is-object.js";
import { HOUR_TO_MS, MINUTE_TO_MS, SECOND_TO_MS } from "./time-constants.js";
export const PosixDateTransformer = {
    from(value) {
        return value ? new PosixDate(value) : null;
    },
    to(value) {
        return value ? value.timestamp : null;
    },
};
export class PosixDate {
    timestamp;
    constructor(timestamp) {
        this.timestamp = timestamp ?? Date.now();
    }
    toJSON() {
        return {
            type: "posix-date",
            timestamp: this.timestamp,
        };
    }
    static fromJson(json) {
        return new PosixDate(json.timestamp);
    }
    static isPosixDateJSON(value) {
        if (isObject(value) &&
            "type" in value &&
            "timestamp" in value &&
            value["type"] === "posix-date" &&
            typeof value["timestamp"] === "number")
            return true;
        return false;
    }
    toLocaleString(opts, locale = "en-US") {
        const currentTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        return new Date(this.timestamp).toLocaleString(locale, {
            timeZone: currentTimezone,
            ...opts,
        });
    }
    isAfter(date) {
        return this.timestamp > date.timestamp;
    }
    isBefore(date) {
        return this.timestamp < date.timestamp;
    }
    isEqualTo(date) {
        return this.timestamp === date.timestamp;
    }
    addHours(hours) {
        return new PosixDate(this.timestamp + hours * HOUR_TO_MS);
    }
    addDays(days) {
        return new PosixDate(this.timestamp + days * HOUR_TO_MS * 24);
    }
    addMinutes(minutes) {
        return new PosixDate(this.timestamp + minutes * MINUTE_TO_MS);
    }
    addSeconds(seconds) {
        return new PosixDate(this.timestamp + seconds * SECOND_TO_MS);
    }
    subtractDays(days) {
        return new PosixDate(this.timestamp - days * HOUR_TO_MS * 24);
    }
    subtractHours(hours) {
        return new PosixDate(this.timestamp - hours * HOUR_TO_MS);
    }
    subtractMinutes(minutes) {
        return new PosixDate(this.timestamp - minutes * MINUTE_TO_MS);
    }
    subtractSeconds(seconds) {
        return new PosixDate(this.timestamp - seconds * SECOND_TO_MS);
    }
    getDateString() {
        return new Date(this.timestamp).toISOString().split("T")[0];
    }
    getTimeString() {
        return new Date(this.timestamp)
            .toISOString()
            .split("T")[1]
            .split(".")[0];
    }
}
